export default "__VITE_ASSET__DRhkMRrr__"